/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/WorkshopItemCategory', 'model/WorkshopWidgetReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/WorkshopItemCategory'), require('../model/WorkshopWidgetReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.WorkshopItemCategoryApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.WorkshopItemCategory, root.ForStractionServiceApi.WorkshopWidgetReport);
  }
}(this, function(ApiClient, WorkshopItemCategory, WorkshopWidgetReport) {
  'use strict';

  /**
   * WorkshopItemCategory service.
   * @module api/WorkshopItemCategoryApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new WorkshopItemCategoryApi. 
   * @alias module:api/WorkshopItemCategoryApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the workshopItemCategoryAddAllPut operation.
     * @callback module:api/WorkshopItemCategoryApi~workshopItemCategoryAddAllPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'Integer'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/WorkshopItemCategory>} body 
     * @param {module:api/WorkshopItemCategoryApi~workshopItemCategoryAddAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'Integer'>}
     */
    this.workshopItemCategoryAddAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopItemCategoryAddAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workshopItemCategoryAddAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Integer'];

      return this.apiClient.callApi(
        '/WorkshopItemCategory/addAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopItemCategoryCategorizeItemsGet operation.
     * @callback module:api/WorkshopItemCategoryApi~workshopItemCategoryCategorizeItemsGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/WorkshopItemCategory>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * categorizeItems
     * @param {String} _4SAPIAppID 
     * @param {Integer} widgetID 
     * @param {module:api/WorkshopItemCategoryApi~workshopItemCategoryCategorizeItemsGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/WorkshopItemCategory>}
     */
    this.workshopItemCategoryCategorizeItemsGet = function(_4SAPIAppID, widgetID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopItemCategoryCategorizeItemsGet";
      }

      // verify the required parameter 'widgetID' is set
      if (widgetID == undefined || widgetID == null) {
        throw "Missing the required parameter 'widgetID' when calling workshopItemCategoryCategorizeItemsGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'widgetID': widgetID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [WorkshopItemCategory];

      return this.apiClient.callApi(
        '/WorkshopItemCategory/categorizeItems', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopItemCategoryDeleteAllPut operation.
     * @callback module:api/WorkshopItemCategoryApi~workshopItemCategoryDeleteAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * deleteAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {module:api/WorkshopItemCategoryApi~workshopItemCategoryDeleteAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.workshopItemCategoryDeleteAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopItemCategoryDeleteAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workshopItemCategoryDeleteAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/WorkshopItemCategory/deleteAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopItemCategoryEditAllPut operation.
     * @callback module:api/WorkshopItemCategoryApi~workshopItemCategoryEditAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/WorkshopItemCategory>} body 
     * @param {module:api/WorkshopItemCategoryApi~workshopItemCategoryEditAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.workshopItemCategoryEditAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopItemCategoryEditAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workshopItemCategoryEditAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/WorkshopItemCategory/editAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopItemCategoryExtractCategoryItemsFromSourcesGet operation.
     * @callback module:api/WorkshopItemCategoryApi~workshopItemCategoryExtractCategoryItemsFromSourcesGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkshopWidgetReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * extractCategoryItemsFromSources
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/WorkshopItemCategoryApi~workshopItemCategoryExtractCategoryItemsFromSourcesGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkshopWidgetReport}
     */
    this.workshopItemCategoryExtractCategoryItemsFromSourcesGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopItemCategoryExtractCategoryItemsFromSourcesGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling workshopItemCategoryExtractCategoryItemsFromSourcesGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = WorkshopWidgetReport;

      return this.apiClient.callApi(
        '/WorkshopItemCategory/extractCategoryItemsFromSources', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
